import * as actions from './customerMaster/actions'
import * as mutations from './customerMaster/mutations'
import * as getters from './customerMaster/getters'

import { dataProps } from './customerMaster/properties'

const state = {
    list: null,
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: []
    },
    autocomplete_list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    statement: {
        date_range: ['', ''],
        list: []
    },
    order_list: [],
    customer_dd: {
        dd_activity: [],
        dd_status: [],
        dd_notes: []
    },
    import_customer_list: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/customerMaster.js